module.exports = require("@ember/utils");